<main class="auth-page" [class.is-medi3]="isMedi3" [class.is-agil]="isAgil" [class.is-mdco]="isDinHms">
  <section class="auth-brand-panel" aria-labelledby="reset-story-title">
    <header class="auth-header">
      <img
        *ngIf="!isMedi3 && !isAgil && !isDinHms"
        class="auth-brand"
        src="assets/images/KubaLogowhite.png"
        alt="Kuba"
      />
      <img
        *ngIf="isMedi3"
        class="auth-brand auth-medi3-logo"
        src="assets/images/Medi3Logo.svg"
        alt="Medi3"
      />
      <img
        *ngIf="isAgil"
        class="auth-brand auth-agil-logo"
        src="assets/icons/agil-logo.png"
        alt="Agil Helse"
      />
      <img
        *ngIf="isDinHms"
        class="auth-brand auth-mdco-logo"
        src="assets/images/mdco/wordmark-white.svg"
        alt="MDCO"
      />
    </header>
    <div class="auth-story">
      <div class="auth-eyebrow">
        <span aria-hidden="true"></span
        >{{ "PASSWORD_RECOVERY.EYEBROW" | translate }}
      </div>
      <h1
        id="reset-story-title"
        class="auth-recovery-title"
        [innerHTML]="'PASSWORD_RECOVERY.STORY_TITLE' | translate"
      ></h1>
      <p class="auth-intro">
        {{ storyIntroKey | translate }}
      </p>
    </div>
    <div *ngIf="!isMedi3" class="auth-brand-bottom">
      <figure *ngIf="!isAgil && !isDinHms" class="auth-mascot" aria-hidden="true">
        <img src="assets/images/kuba-mascot.svg" alt="" />
      </figure>
      <footer class="auth-footer">
        <p class="auth-story-foot">{{ "LOGIN_DESIGN.FOOTER" | translate }}</p>
        <!-- Agil has no published terms page, so it shows the two links it has. -->
        <div class="auth-legal" *ngIf="isAgil; else kubaLegal">
          <a href="https://agilhelse.no" target="_blank" rel="noopener noreferrer"
            >Agil Helse AS</a
          >
          <a
            href="https://agilhelse.no/personvern/"
            target="_blank"
            rel="noopener noreferrer"
            >{{ "LOGIN_DESIGN.PRIVACY" | translate }}</a
          >
        </div>
        <ng-template #kubaLegal>
          <div class="auth-legal">
            <span>Kuba Norge AS</span>
            <a
              href="https://kuba.no/personvernerklaering/"
              target="_blank"
              rel="noopener noreferrer"
              >{{ "LOGIN_DESIGN.PRIVACY" | translate }}</a
            >
            <a
              href="https://kuba.no/vilkar/"
              target="_blank"
              rel="noopener noreferrer"
              >{{ "LOGIN_DESIGN.TERMS" | translate }}</a
            >
          </div>
        </ng-template>
      </footer>
    </div>
  </section>
  <section class="auth-panel" aria-labelledby="reset-title">
    <nav
      class="auth-language"
      [attr.aria-label]="'LOGIN_DESIGN.LANGUAGE' | translate"
    >
      <button
        type="button"
        (click)="setLanguage('no')"
        [attr.aria-pressed]="translate.currentLang() === 'no'"
        aria-label="Norsk"
        title="Norsk"
        lang="no"
      >
        <img *ngIf="!isAgil" src="assets/images/norsk.png" alt="" aria-hidden="true" />
        <span *ngIf="isAgil" aria-hidden="true">NO</span>
      </button>
      <button
        type="button"
        (click)="setLanguage('en')"
        [attr.aria-pressed]="translate.currentLang() === 'en'"
        aria-label="English"
        title="English"
        lang="en"
      >
        <img *ngIf="!isAgil" src="assets/images/english.png" alt="" aria-hidden="true" />
        <span *ngIf="isAgil" aria-hidden="true">EN</span>
      </button>
    </nav>
    <div class="auth-card">
      <a class="auth-link auth-back" [routerLink]="['/login']">
        <i class="pi pi-arrow-left" aria-hidden="true"></i>
        {{ "PASSWORD_RECOVERY.BACK_LOGIN" | translate }}
      </a>
      <h2 id="reset-title">{{ "RESET_PASSWORD" | translate }}</h2>
      <div
        *ngIf="returnValue === 1; else resetContent"
        class="auth-confirmation"
        role="status"
        aria-live="polite"
      >
        <div class="auth-success-mark" aria-hidden="true">
          <i class="pi pi-check"></i>
        </div>
        <p class="auth-card-intro">{{ "PASSWORD_SUCCESS" | translate }}</p>
        <p-button
          [routerLink]="['/login']"
          [label]="'LOGIN' | translate"
          icon="pi pi-arrow-right"
          iconPos="right"
          styleClass="auth-submit"
        />
      </div>
      <ng-template #resetContent>
        <ng-container *ngIf="!regenaratePassword; else expiredLink">
          <form
            class="auth-form auth-reset-form"
            [formGroup]="updatePasswordForm"
            (ngSubmit)="changePassword()"
            [attr.aria-busy]="returnValue === -1"
            novalidate
          >
            <div formGroupName="passwordValidation" class="auth-field">
              <app-password-validator
                (validChange)="onValidChange($event)"
                (passwordChange)="onPasswordChange($event)"
              />
            </div>
            <control-messages
              [control]="updatePasswordForm.controls['passwordValidation']"
            />
            <p-message
              *ngIf="returnValue === 2"
              severity="error"
              styleClass="auth-error"
              >{{ "PASSWORD_EXIST" | translate }}</p-message
            >
            <p-message
              *ngIf="returnValue === 3"
              severity="error"
              styleClass="auth-error"
              >{{ "PASSWORD_TRY_AGAIN" | translate }}</p-message
            >
            <p-message
              *ngIf="returnValue === 4"
              severity="error"
              styleClass="auth-error"
            >
              <ul class="auth-validation-errors">
                <li *ngFor="let err of validationErrors">
                  {{ err | translate }}
                </li>
              </ul>
            </p-message>
            <p-button
              type="submit"
              [label]="'RESET' | translate"
              [loading]="returnValue === -1"
              [disabled]="
                !updatePasswordForm.valid || !userId || returnValue === -1
              "
              icon="pi pi-arrow-right"
              iconPos="right"
              styleClass="auth-submit"
            />
          </form>
        </ng-container>
        <ng-template #expiredLink>
          <p-message severity="error" styleClass="auth-error">{{
            "PASSWORD_REQUEST" | translate
          }}</p-message>
          <p-button
            [routerLink]="['/forget-password']"
            [label]="'PASSWORD_RECOVERY.SEND' | translate"
            icon="pi pi-arrow-right"
            iconPos="right"
            styleClass="auth-submit"
          />
        </ng-template>
      </ng-template>
      <div *ngIf="!isMedi3" class="auth-support">
        <span>{{ "LOGIN_DESIGN.HELP" | translate }}</span>
        <a
          class="auth-link"
          [href]="isAgil ? 'https://agilhelse.no/kontakt-oss/' : 'https://kuba.no/kontakt/'"
          target="_blank"
          rel="noopener noreferrer"
          >{{ "LOGIN_DESIGN.CONTACT" | translate
          }}<i class="pi pi-arrow-up-right" aria-hidden="true"></i
        ></a>
      </div>
    </div>
  </section>
</main>
